module.exports = __webpack_public_path__ + "img/logo.0255990b.png";